module.exports = flarum.core.compat['states/SearchState'];